
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const Salons = lazy(() => import('../pages/salons/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/salons',
    element: <Salons />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
